// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3FUbh","approved":"Status_approved__1WcrI","rejected":"Status_rejected__E_2O-","expired":"Status_expired__1bGqc","label":"Status_label__2GyhH"};